import constants from "../constants";

const { NEW_ALERT_MESSAGE } = constants;

// eslint-disable-next-line import/prefer-default-export
export const newAlertMessage = (data) => ({
  type: NEW_ALERT_MESSAGE,
  data,
});
